import { Box, Checkbox as MuiCheckbox, FormControlLabel } from "@mui/material";
import { Check } from "@mui/icons-material";
import { InputHTMLAttributes, ReactNode } from "react";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  density?: "comfortable" | "compact";
  disabled?: boolean;
  /**
   * `brand`: el `.check` del diseño v2. Casilla de 16px, radio 5 y borde gris; marcada, se rellena con el color
   * de la marca. El label va en 13px gris. `default` es la casilla negra que ya usaban las pantallas.
   */
  variant?: "default" | "brand";
  /** `data-testid` del `<input>` real de la casilla. */
  testId?: string;
}

// TODO: AUN NO ESTA AFINANDO CORRECTAMENTE EL CHECKBOX, REVISAR DESPUES
const CheckboxBox = ({ size, checked }: { size: number; checked: boolean }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: "6px",
      border: "1.5px solid",
      borderColor: checked ? "#000" : "tokens.borderStrong",
      bgcolor: checked ? "#000" : "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all .12s ease",
    }}
  >
    {checked && <Check sx={{ fontSize: size * 0.65, color: "#fff" }} />}
  </Box>
);

/** `.check` del diseño, con la palomita de trazo (`I.Check`) de 11px. */
const CheckboxBrandBox = ({ checked }: { checked: boolean }) => (
  <Box
    sx={{
      width: 16,
      height: 16,
      mt: "1px",
      flexShrink: 0,
      borderRadius: "5px",
      border: "1.5px solid",
      borderColor: checked ? "primary.main" : "tokens.borderStrong",
      bgcolor: checked ? "primary.main" : "background.paper",
      color: "#fff",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background-color .15s cubic-bezier(.25,.8,.35,1), border-color .15s cubic-bezier(.25,.8,.35,1)",
    }}
  >
    {checked && (
      <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
        <polyline points="20 6 9 17 4 12" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )}
  </Box>
);

export const Checkbox = ({
  checked,
  onChange,
  label,
  density = "comfortable",
  disabled,
  variant = "default",
  testId,
}: Props) => {
  const size = density === "compact" ? 16 : 20;
  const isBrand = variant === "brand";

  return (
    <FormControlLabel
      sx={
        isBrand
          ? {
              alignItems: "flex-start",
              ml: 0,
              mr: 0,
              gap: "10px",
              userSelect: "none",
              "& .MuiFormControlLabel-label": { fontSize: 13, lineHeight: 1.45, color: "tokens.textSecondary" },
            }
          : { alignItems: "flex-start", ml: 0, gap: density === "compact" ? 0.5 : 1 }
      }
      disabled={disabled}
      control={
        <MuiCheckbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disableRipple
          inputProps={{ "data-testid": testId } as InputHTMLAttributes<HTMLInputElement>}
          icon={isBrand ? <CheckboxBrandBox checked={false} /> : <CheckboxBox size={size} checked={false} />}
          checkedIcon={isBrand ? <CheckboxBrandBox checked /> : <CheckboxBox size={size} checked={true} />}
          sx={{ p: 0, "&:hover": { bgcolor: "transparent" } }}
        />
      }
      label={label}
    />
  );
};
